import Modal from '@components/Modal';
import styles from './PACSModal.module.scss';
import { useEffect, useState } from 'react';
import PACSModalContent from './PACSModalContent/PACSModalContent';
import PACSModalSideBar from './PACSModalSideBar/PACSModalSideBar';
import { PacsParams } from '@models/pacs';
import useGetDicomNodes, { useGetPacsQuery, useGetPacsRetrieve, UsePacsRetrieveProps } from '@hooks/PACS/usePacs';
export interface PACSModalProps {
  onClose: () => void;
}
export interface RetrieveProps {
  dicomNode: string,
  seriesUID: string
}
const PACSModal = ({ onClose }: PACSModalProps) => {
  const [currentDicomNodeID, setCurrentDicomNodeID] = useState("");
  const {
    data: studyDataRaw,
    fetchData: fetchStudyData,
    isFetching: isFetchingStudyData,
  } = useGetPacsQuery();
  const { data: seriesDataRaw, fetchData: fetchSeriesData } = useGetPacsQuery();
  const {
    fetchData: fetchRetrieveData,
    isFetching: isRetrievingSeries,
  } = useGetPacsRetrieve();

  // DicomNode Lists
  const {
    data: dicomNodeData = [],
    refetch: refetchDicomNodes,
    isFetching: isFetchingDicomNodes,
  } = useGetDicomNodes();

  const [studyData, setStudyData] = useState<any[]>([]);
  const [seriesData, setSeriesData] = useState<any[]>([]);
  const [hasStudyQuerySubmitted, setHasStudyQuerySubmitted] = useState(false);

  useEffect(() => {
    if (studyDataRaw) setStudyData(studyDataRaw);
  }, [studyDataRaw]);

  useEffect(() => {
    if (seriesDataRaw) setSeriesData(seriesDataRaw);
  }, [seriesDataRaw]);

  // Study Query Button
  const handlePACSStudyQuery = async (newQuery: PacsParams) => {
    setStudyData([]);
    setSeriesData([]);
    setHasStudyQuerySubmitted(false);

    const queryResult = await fetchStudyData(newQuery, true);
    if (queryResult) {
      setStudyData(queryResult);
      setHasStudyQuerySubmitted(true);
    }
  };

  // Series Query Button
  const handlePACSSeriesQuery = async (newQuery: PacsParams) => {
    setSeriesData([]);
    if(newQuery.StudyUID===''){
      return;
    }
    await fetchSeriesData(newQuery, false);
  };

  const handleRetrieve = async(
    { dicomNode, seriesUID } : UsePacsRetrieveProps
  ) => {
    const retrieveResult = await fetchRetrieveData({ dicomNode, seriesUID });
    if (retrieveResult) {
      onClose();
    }
  };

  const handleClearAll = () => {
    setStudyData([]);
    setSeriesData([]);
    setHasStudyQuerySubmitted(false);
  };

  return (
    <Modal
      type="page"
      className={styles["pacsModal"]}
      close={onClose}
      description={
        <div className={styles["container"]}>
          {/* <div className="pacs-container-sidebar"> */}
            <PACSModalSideBar
              onSubmitQuery={handlePACSStudyQuery}
              DicomNodes={dicomNodeData}
              setDicomNode={setCurrentDicomNodeID}
              onClearAll={handleClearAll}
            />
          {/* </div>
          <div className="pacs-container-content"> */}
            <PACSModalContent
              onSeriesFetch={handlePACSSeriesQuery}
              onRetrieveSeries={handleRetrieve}
              isRetrievingSeries={isRetrievingSeries}
              isFetchingStudy={isFetchingStudyData}
              hasStudyQuerySubmitted={hasStudyQuerySubmitted}
              study_data={studyData ?? []}
              series_data={seriesData ?? []}
              dicomNode_data={currentDicomNodeID}
              onClose={onClose}
            />
          {/* </div> */}
        </div>
      }
    />
  );
};

export default PACSModal;
